import { render, staticRenderFns } from "./RsDashboard.vue?vue&type=template&id=456c2ac5&scoped=true"
import script from "./RsDashboard.vue?vue&type=script&lang=js"
export * from "./RsDashboard.vue?vue&type=script&lang=js"
import style0 from "./RsDashboard.vue?vue&type=style&index=0&id=456c2ac5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c2ac5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456c2ac5')) {
      api.createRecord('456c2ac5', component.options)
    } else {
      api.reload('456c2ac5', component.options)
    }
    module.hot.accept("./RsDashboard.vue?vue&type=template&id=456c2ac5&scoped=true", function () {
      api.rerender('456c2ac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/RsDashboard.vue"
export default component.exports